module.exports = "{{ 'periodic_tasks.repeater_configurator.at_the_following_months' | translate }}\n{{ TaskDetailsCtrl.taskDetails.repeater_config | monthsDisplay }}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/app/components/periodic_tasks/task_details/display_months.html
// module id = 745
// module chunks = 0